import { Routes } from "@angular/router";
import { authGuard } from "./guards/logged_in.guard";

export const appRoutes: Routes = [
    {
        path: "dashboard",
        canActivate: [authGuard],
        loadChildren: () =>
            import("./modules/dashboard/dashboard.routes").then(
                (m) => m.dashboardRoutes
            ),
    },
    {
        path: "staging-login-wall",
        loadChildren: () =>
            import(
                "./modules/login-staging-wall/login-staging-wall.routes"
            ).then((m) => m.loginStagingWallRoutes),
    },
    {
        path: "",
        loadChildren: () =>
            import("./modules/overview/overview.routes").then(
                (m) => m.overviewRoutes
            ),
    },
    { path: "**", redirectTo: "" },
];
